module.exports = __webpack_public_path__ + "05_medium_gray.ada7e562.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/05_medium_gray.png
// module id = zrDK
// module chunks = 0